import actionTypes from '../../actions/bill/revSettle/actionType';

const initialState = {
  settledBillListLoading: false,
  settledBillList: [], // 已结账单列表
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_SETTLED_BILL_LIST_LOADING:
      const { settledBillListLoading } = payload;
      return {
        ...state,
        settledBillListLoading,
      };
    case actionTypes.INIT_SETTLED_BILL_LIST:
      const { settledBillList } = payload;
      return {
        ...state,
        settledBillList,
      };

    default:
      return state;
  }
};
